<script setup lang="ts">
import { computed } from 'vue';

interface PR {
  repo_name: string;
  number: number;
  title: string;
  ai_contribution?: string;
  created_at: string;
  merged_at?: string;
  html_url: string;
}

interface Props {
  prsCreated: PR[];
  prsMerged: PR[];
}

const { prsCreated, prsMerged } = defineProps<Props>();

const allPrs = computed(() => {
  const created = prsCreated.map(pr => ({ ...pr, type: 'created' as const }));
  const merged = prsMerged.map(pr => ({ ...pr, type: 'merged' as const }));
  return [...created, ...merged].sort((a, b) => {
    // Sort by creation date, newest first
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });
});
</script>

<template>
  <div v-if="allPrs.length > 0" class="space-y-2">
    <div
      v-for="pr in allPrs"
      :key="`${pr.repo_name}-${pr.number}-${pr.type}`"
      class="flex items-center gap-2 justify-start"
    >
      <i 
        class="pi pi-github"
      />
      <Tag
        :value="pr.repo_name"
        :severity="pr.type === 'created' ? 'info' : 'success'"
        v-tooltip.top="pr.type === 'created' ? 'Created' : 'Merged'"
        class="!text-xs"
      />
      <a
        :href="pr.html_url"
        target="_blank"
        rel="noopener noreferrer"
        class="text-sm text-link"
        :title="pr.title"
      >
        {{ pr.title }}
      </a>
    </div>
  </div>
</template>
